import type { QueryObserverResult } from '@tanstack/react-query'
import type { AxiosError } from 'axios'

import type { TCliente } from '@/types/cliente'
import { StringUtils } from '@/utils/string.utils'

export type FetchResult<TPatch> =
  | { type: 'SUCCESS'; patch: TPatch }
  | { type: 'NOT_FOUND'; shouldOpenModal?: boolean }
  | { type: 'INACTIVE'; patch: TPatch }
  | { type: 'ERROR' }

export abstract class BasePessoaFisicaUseCase<TCompradorStep> {
  protected constructor() {}

  validarAvanco(cpf: string, buscouCpf: boolean): { ok: boolean; error?: 'MISSING_CPF' | 'NEED_SEARCH' } {
    if (!cpf) return { ok: false, error: 'MISSING_CPF' }
    if (!buscouCpf) return { ok: false, error: 'NEED_SEARCH' }
    return { ok: true }
  }
  protected cpfIgual(a?: string | null, b?: string | null) {
    return StringUtils.normalize(a ?? '') === StringUtils.normalize(b ?? '')
  }

  abstract interpretarResultadoBuscaManual(
    result: QueryObserverResult<TCliente, AxiosError>,
    formId?: string,
  ): FetchResult<Partial<TCompradorStep>>
}
